<template>
    <section id="contact">
        <AccordionItem 
        id="19"
        sectionId="DesignContact"
        sectionName="Contacto"
        spanName="Contacto"
        :defaultOpen="true"
        :clickedFunction="animationItems"
        @update-state="handleAccordionUpdate">
            <ContactInfo :isAccordionOpen="isAccordionOpen" />
        </AccordionItem>
    </section>
</template>

<script>
import AccordionItem from '@/components/AccordionItem.vue';
import ContactInfo from './ContactInfo.vue';

export default {
    name: 'DesignContact',
    components: {
        AccordionItem, ContactInfo,
    },
    data() {
        return {
            isAccordionOpen: true,
            resizeTimeout: null,
            scrollTimeout: null,
            scrolling: false,
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll, { passive: true });
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        clearTimeout(this.resizeTimeout);
        clearTimeout(this.scrollTimeout);
    },
    methods: {        
        handleScroll() {
            this.scrolling = true;
            clearTimeout(this.scrollTimeout);
            this.scrollTimeout = setTimeout(() => {
                this.scrolling = false;
            }, 200);
        },

        animationItems() {
            if (this.scrolling) return;
            
            const button = document.getElementById("contact-statue");
            if (!button) return;
            
            if (this.isAccordionOpen) {
                button.classList.remove("animate__slideOutDown");
                button.classList.add("animate__slideInUp");
            } else { 
                button.classList.add("animate__slideOutDown");
                button.classList.remove("animate__slideInUp");
            }
        },

        handleAccordionUpdate(newStatus) {
            this.isAccordionOpen = newStatus;
            this.$nextTick(() => {
                if (!this.scrolling) {
                    this.animationItems();
                }
            });
        },

        openAccordion() {
            if (!this.isAccordionOpen) {
                this.isAccordionOpen = true;
                this.$nextTick(() => {
                    this.animationItems();
                });
            }
        },
    },
}
</script>

<style scoped>
section{
    padding: 0 5vw 4vw;
}
.container{
    padding-bottom: 2vw;
}
</style>